import { useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks";
import {
  enableScrollScreen,
  showComboDetailModal,
  showProductDetailModal,
} from "../../store/slices/uiSlice";
import { IProduct } from "../../types/product";
import CloseIcon from "../../assets/icons/CloseIcon";
import MinusIcon from "../../assets/icons/MinusIcon";
import PlusIcon from "../../assets/icons/PlusIcon";
import { addProductToCart, addProductToCartWithQuantity, clearProductInCart, removeProductInCart, updateQuantityProductInCart } from "../../store/slices/cartSlice";
import PreviousIcon from "../../assets/icons/PreviousIcon";
import NextIcon from "../../assets/icons/NextIcon";
import { productPrvSliceActions } from "../../store/slices/productSlice";
import ShareIcon from "../../assets/icons/ShareIcon";
import Tooltip from "../tooltip/Tooltip";
import { getCartState, getComboState } from "../../store";
import CheckIcon from "../../assets/icons/CheckIcon";
import StarIcon from "../../assets/icons/StarIcon";
import PlayVideoIcon from "../../assets/icons/PlayVideoIcon";
import { toast } from "react-toastify";
import { formatProductInCart } from "../../helpers/handleProduct";
import { isEmptyObject } from "../../helpers/handleObject";
import { setComboSelected } from "../../store/slices/comboSlice";
import { ICombo } from "../../types/combo";
import ArrowLeftIcon from "../../assets/icons/ArrowLeftIcon";
import { formatHTMLString } from "../../helpers/handleString";
interface IModalProductProps {
  product: IProduct;
}
interface IWholesaleItem {
    quantity: number | string;
    sale_price: number | string;
}
const formatCurrency = (number: unknown): string => {
    if (number === undefined || number === null || number === '') return '0';
    
    // Đảm bảo là số trước khi format, và xử lý cả string lẫn number
    const numberAsString = String(number);
    
    // Loại bỏ dấu chấm (nếu có, thường dùng trong định dạng tiền tệ đã format)
    const num = Number(numberAsString.replace(/\./g, '').replace(/,/g, ''));
    
    if (isNaN(num)) return numberAsString;
    return num.toLocaleString("vi-VN");
};
const normalizeWholesaleList = (wholesalePrice: unknown): { quantity: number; sale_price: number }[] => {
  if (!wholesalePrice) return [];

  let wholesaleData: IWholesaleItem[] = [];
  if (Array.isArray(wholesalePrice)) {
    wholesaleData = wholesalePrice as IWholesaleItem[];
  } else if (typeof wholesalePrice === "string") {
    try {
      wholesaleData = JSON.parse(wholesalePrice) as IWholesaleItem[];
    } catch (e) {
      console.error("Lỗi parse JSON wholesale_price:", e);
      return [];
    }
  } else {
    return [];
  }

  return wholesaleData
    .map(item => ({
      quantity: Number(item.quantity),
      sale_price: Number(item.sale_price)
    }))
    .filter(item => item.quantity > 0 && item.sale_price > 0);
};

const getWholesalePrice = (quantity: number, wholesalePrice: unknown, defaultPrice: number | string): number => {
  const wholesaleData = normalizeWholesaleList(wholesalePrice);
  if (wholesaleData.length === 0) {
    return Number(defaultPrice);
  }

  const sortedData = [...wholesaleData].sort((a, b) => a.quantity - b.quantity);
  let appliedPrice = Number(defaultPrice);

  for (let i = sortedData.length - 1; i >= 0; i--) {
    const item = sortedData[i];
    if (quantity >= item.quantity) {
      appliedPrice = item.sale_price;
      break;
    }
  }

  return appliedPrice;
};
export default function ModalProductDetail({ product }: IModalProductProps) {
  const dispatch = useAppDispatch();
  const { cartInfo } = useAppSelector(getCartState);
  const { comboSelected } = useAppSelector(getComboState)
  const [indexImage, setIndexImage] = useState<number>(0);
  const [productChilds, setProductChilds] = useState<IProduct[]>([])
  const [productChildSelected, setProductChildSelected] = useState<IProduct>()
  const [isCopied, setIsCopied] = useState<boolean>(false);
  const [videoShow, setVideoShow] = useState<string>("");
  const [imageShow, setImageShow] = useState<string>("");


  const productInCart = useMemo(() => {
    const id = productChildSelected ? productChildSelected.id : product.id;
    return cartInfo.find(item => item.id === id);
  }, [cartInfo, product, productChildSelected])
  const [quantity, setQuantity] = useState<number>(() => productInCart ? productInCart.quantity : 1);
  const unitPriceByQuantity = useMemo(() => {
      // Lấy giá bán lẻ (price_sale) hoặc giá sản phẩm con (nếu có)
      const priceSale = Number(productChildSelected?.price_sale || product.price_sale || 0);
      const wholesalePrice = productChildSelected?.wholesale_price || product.wholesale_price;

      // Trả về Đơn giá (unit price) sau khi áp dụng chính sách sỉ
      return getWholesalePrice(
          quantity, 
        wholesalePrice,
          priceSale
      );
  }, [quantity, product, productChildSelected]);
    // Tính TỔNG TIỀN cho số lượng đang chọn
  const totalPrice = useMemo(() => {
      return unitPriceByQuantity * quantity;
  }, [unitPriceByQuantity, quantity]);
  useEffect(() => {
    const fetchProductDetail = async () => {
      const res = await dispatch(productPrvSliceActions.getProductDetail(product.slug));
      if (!(res.payload as any)) return;
      setProductChilds(prev => prev = (res.payload as any).child)
    }
    fetchProductDetail();
  }, [product, dispatch])
  useEffect(() => {
  if (productChildSelected) {
    const photo = productChildSelected.thumb_url || "http://static.salekit.com/public/images/no-image.png";

    setImageShow(photo);
  } else {
    const photo = product.thumb_url|| "http://static.salekit.com/public/images/no-image.png";

    setImageShow(photo);
  }
}, [productChildSelected, product]);
  const handleNextImage = () => {
    if (indexImage + 1 === product.photos.length) {
      setImageShow((prev) => (prev = product.photos && product.photos[0]));
      setIndexImage((prev) => (prev = 0));
      return;
    }
    setImageShow((prev) => (prev = product.photos[indexImage + 1]));
    setIndexImage((prev) => (prev = prev + 1));
  };
  const handleBackImage = () => {
    if (indexImage === 0) {
      const lastIndex = product.photos.length - 1;
      setImageShow((prev) => (prev = product.photos[lastIndex]));
      setIndexImage((prev) => (prev = lastIndex));
      return;
    }
    setImageShow((prev) => (prev = product.photos[indexImage - 1]));
    setIndexImage((prev) => (prev = prev - 1));
  };
  let touchStartX = 0;
  let touchEndX = 0;
  const handleGesture = () => {
    if (touchEndX < touchStartX) {
      handleNextImage();
    }
    if (touchEndX > touchStartX) {
      handleBackImage();
    }
  };
  const handleTouchStart = (e: any) => {
    touchStartX = e.changedTouches[0].screenX;
  };
  const handleTouchEnd = (e: any) => {
    touchEndX = e.changedTouches[0].screenX;
    handleGesture();
  };

  const renderWholesalePriceTable = () => {
      const selectedProduct = productChildSelected || product;
      const wholesaleData = normalizeWholesaleList(selectedProduct?.wholesale_price);
      if (wholesaleData.length <= 1) {
        return null;
      }

      const sortedData = [...wholesaleData].sort((a, b) => a.quantity - b.quantity);

        // 2. Hàm để tạo range Số lượng (ví dụ: 1-2, 3-9, >=10)
        const createQuantityRange = (index: number) => {
            const currentQty = Number(sortedData[index].quantity);
            if (index === sortedData.length - 1) {
                // Dòng cuối cùng: >= [currentQty] sản phẩm
                return `>= ${formatCurrency(currentQty)}`; // Sử dụng formatCurrency
            } else {
                // Các dòng giữa: [currentQty] - [Qty kế tiếp - 1] sản phẩm
                const nextQty = Number(sortedData[index + 1].quantity);
                const endRange = nextQty - 1;

                if (endRange > currentQty) {
                    return `${formatCurrency(currentQty)} - ${formatCurrency(endRange)}`; // Sử dụng formatCurrency
                } else if (endRange === currentQty) {
                    return `${formatCurrency(currentQty)}`; // Sử dụng formatCurrency
                }
                return `${formatCurrency(currentQty)}`; // Trường hợp khác
            }
        };

        // Bổ sung HTML/JSX cho bảng giá sỉ
        return (
            <div className="px-6 my-4">
                <h3 className="text-medium">
                        Bảng giá sỉ
                </h3>
                <div className="border border-gray-300 rounded-sm overflow-hidden">
                    
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr className="bg-gray-50">
                                <th className="px-3 py-2 text-left text-sm font-medium  tracking-wider w-2/3">
                                    Số lượng
                                </th>
                                <th className="px-3 py-2 text-right text-sm font-medium  tracking-wider w-1/3">
                                    Đơn giá
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {sortedData.map((item, index) => (
                                <tr key={index} className="hover:bg-gray-50">
                                    <td className="px-3 py-2 text-left text-sm font-semibold text-gray-900">
                                        {createQuantityRange(index)} <span className="px-1 text-left text-sm font-normal text-gray-500">sản phẩm</span>
                                    </td>
                                    <td className="px-3 py-2 text-right text-sm text-gray-900 font-normal ">
                                        {formatCurrency(item.sale_price)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center pt-10 pb-4 max-md:p-0">
      <div className="bg-white w-full max-w-[750px] rounded-sm shadow-xl flex flex-col justify-between gap-3 max-md:w-full max-xl:w-[80%] max-md:gap-0">
        <div className="px-6 py-3 flex justify-between gap-2 items-center border-b border-gray-300 border-solid">
          <div className="flex items-center gap-2">
            {!isEmptyObject(comboSelected) && <button
              onClick={() => {
                dispatch(setComboSelected(comboSelected))
                dispatch(showProductDetailModal());
                dispatch(showComboDetailModal());
              }}
            >
              <ArrowLeftIcon />
            </button>}
            <p className="text-xl font-medium">{productChildSelected ? productChildSelected.name : product.name}</p>
          </div>
          <div className="flex items-center gap-4">
            <Tooltip content={isCopied ? "Đã sao chép" : "Sao chép"}>
              <button
                className="active:opacity-70"
                onClick={() => {
                  setIsCopied(prev => prev = true);
                  navigator.clipboard.writeText(`${window.location.origin}/product/${product.slug}`);
                }}
              >
                <ShareIcon />
              </button>
            </Tooltip>
            <button
              onClick={() => {
                dispatch(showProductDetailModal());
                dispatch(enableScrollScreen());
                dispatch(setComboSelected({} as ICombo));
              }}
            >
              <CloseIcon />
            </button>
          </div>
        </div>
        <div className="overflow-y-auto flex-1">
          <div className="flex flex-col gap-6 p-6 max-md:px-0 max-md:pt-0">
            <div className="flex justify-center relative">
              {product.photos && product.photos.length > 1 && !productChildSelected && (
                <div
                  className="absolute rounded-full p-2 -left-4 top-1/2 shadow-md cursor-pointer bg-[#DEDFE1] max-md:hidden"
                  onClick={handleBackImage}
                >
                  <PreviousIcon />
                </div>
              )}
              {videoShow ?
                <iframe
                  title="YouTube video player"
                  src={videoShow}
                  style={{ aspectRatio: "16/9", width: "100%", height: "100%" }}
                  allowFullScreen
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                >
                </iframe>
                : <img
                  key={imageShow}
                  src={imageShow ? imageShow : "http://static.salekit.com/public/images/no-image.png"}
                  alt="Ảnh"
                  className="w-full max-h-[500px] object-contain aspect-square"
                  onTouchStart={handleTouchStart}
                  onTouchEnd={handleTouchEnd}
                />}
              {product.photos && product.photos.length > 1 && !productChildSelected && (
                <div
                  className="absolute rounded-full p-2 -right-4 top-1/2 shadow-md cursor-pointer bg-[#DEDFE1] max-md:hidden"
                  onClick={handleNextImage}
                >
                  <NextIcon />
                </div>
              )}
              <div className="hidden absolute bottom-2 max-md:flex justify-center items-center gap-2">
                {product.photos && product.photos.length > 1 &&
                  product.photos.map((img, index) => (
                    <div
                      key={index}
                      className={
                        index === indexImage
                          ? "p-1.5 rounded-full bg-[#E8EAEB]"
                          : "p-1.5 rounded-full bg-[#747C87]"
                      }
                      onClick={() => {
                        setImageShow((prev: string) => (prev = img));
                        setIndexImage(index);
                      }}
                    ></div>
                  ))}
              </div>
              {/* {product.photos.length > 0 && <div className="absolute -top-6 -right-6 max-md:top-[6px] max-md:right-[6px] bg-[#BCBFC2] rounded-xl px-2 text-white">
                {indexImage + 1} / {product.photos.length}
              </div>} */}
            </div>
            {product.photos
              && product.photos.length > 1
              && !productChildSelected
              && <div className="flex flex-col gap-3">
                <div className="w-full h-fit grid grid-cols-3 gap-2 max-md:hidden">
                  {product.photos?.map((img, index) => (
                    <button
                      key={index}
                      className={
                        imageShow === img
                          ? " border-blue-600 border-2 border-solid flex justify-center"
                          : "hover:border-blue-600 border-2 border-solid border-transparent flex justify-center"
                      }
                    >
                      <img
                        src={img}
                        alt="Ảnh"
                        className="p-1 w-full size-20 aspect-square object-contain"
                        onClick={() => {
                          setImageShow((prev: string) => (prev = img));
                          setVideoShow((prev) => prev = "");
                          setIndexImage(index);
                        }}
                      />
                    </button>
                  ))}
                </div>
                {product.video_url &&
                  <button className={`flex justify-center items-center size-20 ${videoShow && "border-blue-600 border-2 border-solid"}`}
                    onClick={() => {
                      setVideoShow((prev) => prev = product.video_url.replace("https://youtu.be", "https://youtube.com/embed"));
                      setImageShow((prev) => prev = "");
                    }}
                  >
                    <PlayVideoIcon />
                  </button>
                }
              </div>}
          </div>
          {productChilds && productChilds.length > 0 && <div className="flex flex-col gap-2 px-6 pb-2">
            <div className="p-1 max-w-fit text-xs font-normal uppercase text-red-600">Phân loại sản phẩm</div>
            <div className="flex items-center flex-wrap gap-2">
              {productChilds.map(productChild => (                
                <div
                  key={productChild.id}
                  className={`flex items-center gap-2 border border-solid rounded-md text-center p-1 cursor-pointer ${productChildSelected?.id === productChild.id ? "border-blue-600" : "border-gray-300"}`}
                  onClick={() => {
                    if (productChildSelected && productChildSelected.id === productChild.id) {
                      // Bỏ chọn sản phẩm con
                      setProductChildSelected(undefined);
                      // Hiển thị lại ảnh sản phẩm cha
                      const photo =
                        Array.isArray(product.photos) && product.photos.length > 0
                          ? product.photos[0]
                          : product.photos || "http://static.salekit.com/public/images/no-image.png";
                      setImageShow(Array.isArray(photo) ? photo[0] : photo);

                    } else {
                      // Chọn sản phẩm con
                      setProductChildSelected(productChild);
                      // Hiển thị ảnh tương ứng sản phẩm con
                      const photo = productChild.thumb_url || "http://static.salekit.com/public/images/no-image.png";
                      setImageShow(photo);

                    }

                  }}
                >
                  <img
                    src={
                      productChild.thumb_url || "http://static.salekit.com/public/images/no-image.png"
                    }
                    alt="image-product-child"
                    className="size-8 object-contain aspect-square"
                  />

                  <p className="text-xs font-normal">{productChild.name}</p>
                </div>
              ))}
            </div>
          </div>}
          <div className="px-6 flex items-center justify-between">
            <div className="flex items-center">
              {product.price_sale && <div className=" red text-[red] text-base font-medium">{Number(product.price_sale).toLocaleString("vi-VN")}</div>}
              <p className="line-through text-sm font-normal cursor-pointer"
                style={{ color: "rgba(70, 81, 95, 0.5)" }}
              >
              </p>
              {+product.unit_price > 0
                  && +product.unit_price !== +product.price_sale
                  && <p className=" px-3 line-through text-sm font-normal cursor-pointer"
                style={{ color: "rgba(70, 81, 95, 0.5)" }}
                >
                  {Number(product.unit_price).toLocaleString("vi-VN")}
                </p>}
              </div>
              <div className="flex items-center" style={{color: "rgba(253, 241, 3, 0.96)"}}> 
              {/* Màu vàng sẽ được truyền qua currentColor */}
                <StarIcon size={30}/> 
                <StarIcon size={30}/> 
                <StarIcon size={30}/> 
                <StarIcon size={30}/> 
                <StarIcon size={30}/> 
            </div>
          </div> 
          {/* BẢNG GIÁ SỈ ĐÃ SỬA */}
            {renderWholesalePriceTable()}
          {product.description && <div
            id="product-description"
            className="px-6"
            dangerouslySetInnerHTML={{ __html: formatHTMLString(product.description) }}
          >
          </div>}
          {product.content && <div
            id="product-content"
            className="px-6"
            dangerouslySetInnerHTML={{ __html: formatHTMLString(product.content) }}
          ></div>}
        </div>
        <div className="p-4 flex flex-col gap-4 border-t border-gray-300 border-solid">
          <div className="flex justify-between items-center">
            <div className="flex w-full items-center gap-4">
              <p className="text-base font-normal">Số lượng</p>
              <div className="flex items-center gap-2 flex-1">
                <button
                  onClick={() => {
                  if (quantity < 2) {
                      const id = productChildSelected ? productChildSelected.id : product.id;
                      dispatch(clearProductInCart({ id: id })); // Xóa nếu số lượng về 0
                      setQuantity(1);
                      return;
                  }
                      const newQuantity = quantity - 1;
                      setQuantity(newQuantity);
                      // Cập nhật số lượng trong giỏ hàng
                      const id = productChildSelected ? productChildSelected.id : product.id;
                      dispatch(updateQuantityProductInCart({ id: id, quantity: newQuantity }))
                  }}
                >
                  <MinusIcon />
                </button>
                <input
                  type="text"
                  value={quantity}
                  // ... (Phần onChange và onBlur vẫn giữ nguyên để xử lý input thủ công)
                  className="w-20 text-center outline-none border-b border-gray-200 border-solid"
                  onChange={(ev) => {
                      const value = +ev.target.value;
                      setQuantity((prev) => prev = value);
                  }}
                  onBlur={() => {
                      const id = productChildSelected ? productChildSelected.id : product.id;
                      if (!quantity || quantity < 1) { // Đảm bảo số lượng ít nhất là 1 hoặc xóa
                          dispatch(clearProductInCart({ id: id }));
                          setQuantity(1);
                      } else {
                          dispatch(updateQuantityProductInCart({ id: id, quantity: quantity }))
                      }
                  }}
                />
                <button onClick={() => {
                  const newQuantity = quantity + 1;
                  setQuantity(newQuantity);
                  // Cập nhật số lượng trong giỏ hàng
                  const id = productChildSelected ? productChildSelected.id : product.id;
                  if (productInCart) {
                      dispatch(updateQuantityProductInCart({ id: id, quantity: newQuantity }))
                  }
                }}>
                  <PlusIcon />
                </button>
              </div>
              <h1 className="font-medium text-base">
                {Number(unitPriceByQuantity).toLocaleString("vi-VN")}
              </h1>
            </div>
          </div>
          <button
            className="w-full flex justify-center gap-2 items-center bg-[#0088FF] text-white text-xl font-medium px-3 py-2 rounded-md"
            onClick={() => {
              if (product.has_child && !productChildSelected) return toast.error("Vui lòng chọn sản phẩm");
              if (productInCart) return;
              dispatch(
                addProductToCartWithQuantity({
                  quantity: quantity,
                  product: productChildSelected
                    ? formatProductInCart(productChildSelected, "product")
                    : formatProductInCart(product, "product"),
                })
              );
              // dispatch(showProductDetailModal());
              // dispatch(enableScrollScreen());
            }}
          >
            {productInCart && <CheckIcon width="28" height="28" />}
            {productInCart ? "Đã thêm vào giỏ hàng" : "Thêm vào giỏ hàng"}
          </button>
        </div>
      </div>
    </div >
  );
}
